/**
 * @fileDesc: umu web产品的统计
 */
const Lang = window.pageData?.config?.lang || 'zh-cn';

export const statistic = (function () {
    const browserInfo = (function () {
        function getBrowserType() {
            const ua = navigator.userAgent;
            if (ua.indexOf('MSIE') > 0) {
                return 'MSIE';
            }
            if (ua.indexOf('Firefox') > 0) {
                return 'Firefox';
            }
            if (ua.indexOf('Safari') > 0 && ua.indexOf('Chrome') < 0) {
                return 'Safari';
            }
            if (ua.indexOf('Safari') > 0 && ua.indexOf('Chrome') > 0) {
                return 'Chrome';
            }
            if (ua.indexOf('Gecko/') > 0) {
                // ie11
                return 'Gecko';
            }

            return (ua as any).appName;
        }

        function getBrowserVersion() {
            // Use of jQuery.browser is frowned upon.
            // More details: http://api.jquery.com/jQuery.browser
            // jQuery.uaMatch maintained for back-compat
            const uaMatch = function (ua: string) {
                ua = ua.toLowerCase();

                const match =
                    /(chrome)[ /]([\w.]+)/.exec(ua) ||
                    /(webkit)[ /]([\w.]+)/.exec(ua) ||
                    /(opera)(?:.*version|)[ /]([\w.]+)/.exec(ua) ||
                    /(msie) ([\w.]+)/.exec(ua) ||
                    (ua.indexOf('compatible') < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua)) ||
                    [];

                return {
                    browser: match[1] || '',
                    version: match[2] || '0'
                };
            };

            const matched = uaMatch(navigator.userAgent);
            const browser: any = {};

            if (matched.browser) {
                browser[matched.browser] = true;
                browser.version = matched.version;
            }

            // Chrome is Webkit, but Webkit is also Safari.
            if (browser.chrome) {
                browser.webkit = true;
            } else if (browser.webkit) {
                browser.safari = true;
            }

            return browser;
        }

        return {
            userAgent: navigator.userAgent,
            cookieEnabled: navigator.cookieEnabled,
            language: navigator.language,
            appName: getBrowserType(),
            appVersion: getBrowserVersion().version,
            screen: `${window.screen.width}x${window.screen.height}`,
        };
    })();

    const appLanguage = (function () {
        return Lang;
    })();

    const umuStatistic = {
        /**
         *
         * actionName:     SPA注册    TTS登录/打开APP    SPA登录/打开APP    TTS新建课程    TTS付费
         * TTSRegsiter    SPARegister    TTSLogin    SPALogin    TTSCreateGroup    TTSPay
         *
         * 注册 - 相关PIN
         软件平台(web,wap,iOS,Android)
         软件版本(1.1.1)
         软件语言(zh-cn,zh-tw,en,ja-jp....)
         操作系统版本(window7,mac os x 10.10,iOS8.1,Android5.1)
         操作系统语言(zh-cn,zh-tw,en,ja-jp....)
         web浏览器名称(chrome,firefox,IE.....)
         web浏览器版本(1.1.1)
         App软件来源(官网,App各个渠道)
         App设备型号(iPhone5s,Nexus5....)
         手机sim卡运营商(中国移动,中国联通,中国电信....)
         手机网络(wifi，2G，3G，4G)
         IP地址(11.111.111.111)
         *
         * */

        actionType: {
            TTSRegsiter: 'TTSRegister',
            SPARegister: 'SPARegister',
            TTSLogin: 'TTSLogin',
            SPALogin: 'SPALogin',
            TTSCreateGroup: 'TTSCreateGroup',
            TTSPay: 'TTSPay'
        },

        browserInfo,

        // 获取跟踪信息
        getTrackInfo(info: any) {
            if (!info) {
                return '';
            }

            const newInfo = {
                actionName: info.action || '',
                pin: info.pin || '',
                platform: 'web',
                version: '2.0',
                userLanguage: appLanguage,
                systemLanguage: browserInfo.language,
                browserName: browserInfo.appName,
                browserVersion: browserInfo.appVersion,
                appSource: '',
                simCarrier: '',
                networkState: '',
                screen: browserInfo.screen,
                ip: ''
            };

            return JSON.stringify(newInfo);
        },

        // TTS注册
        trackTTSRegsiter() {
            return umuStatistic.getTrackInfo({ action: umuStatistic.actionType.TTSRegsiter });
        },

        // TTS登录/打开APP
        trackTTSLogin() {
            return umuStatistic.getTrackInfo({ action: umuStatistic.actionType.TTSLogin });
        },

        // TTS新建课程
        trackTTSCreateGroup() {
            return umuStatistic.getTrackInfo({ action: umuStatistic.actionType.TTSCreateGroup });
        },

        // TTS付费
        trackTTSPay() {
            return umuStatistic.getTrackInfo({ action: umuStatistic.actionType.TTSPay });
        }
    };

    return umuStatistic;
})();
